// @ts-nocheck
import * as React from "react";
import { OrgAvailability } from "./design/screens/mobile-org";
import { ResourceSearch } from "./design/screens/resource-search";
import { ReferralInbox } from "./design/screens/mobile-referrals";
import { createRoot } from "react-dom/client";

import { DesignCanvas, DCSection, DCArtboard } from "./design/canvas";
import { LandingDesktop } from "./design/screens/landing-desktop";
import { LandingMobile } from "./design/screens/landing-mobile";
import { Auth } from "./design/screens/auth";
import { Signup } from "./design/screens/signup";
import { DashboardRegion } from "./design/screens/dashboard-region";
import { DashboardPlatform } from "./design/screens/dashboard-platform";
import { DashboardCareManager } from "./design/screens/dashboard-caremanager";
import { DashboardGuardian } from "./design/screens/dashboard-guardian";
import { DashboardElder } from "./design/screens/dashboard-elder";
import { DashboardAgency } from "./design/screens/dashboard-agency";
import { COD } from "./design/screens/cod";
import { MapView } from "./design/screens/map";
import { Schedule } from "./design/screens/schedule";
import { Approval } from "./design/screens/approval";
import { RegionManagement } from "./design/screens/region-management";
import { OrgManagement } from "./design/screens/org-management";
import { Management } from "./design/screens/management";
import { ElderlyDetail } from "./design/screens/elderly-detail";
import { MgrCases } from "./design/screens/mgr-cases";
import { MgrCaseDesktop } from "./design/screens/mgr-case-desktop";
import { VisitDetail } from "./design/screens/visit-detail";
import { MgrSchedule } from "./design/screens/mgr-schedule";
import {
  MgrHome, MgrVisit, MgrMatch, MgrMap, MgrCase, MgrCaseList, MgrReport, MgrReportsMobile, MgrMe, MgrNotify,

  MgrPrivacy, MgrTerms,
} from "./design/screens/mobile-manager";
import {
  CareApply, NotifyCenter, VisitTimeline, MedCenter, GuardianMe, GuardianManager, ElderHelp, MessageThread,
} from "./design/screens/mobile-guardian";
import { Sos } from "./design/screens/sos";
import { Report } from "./design/screens/report";
import { Claims } from "./design/screens/claims";
import { Admins } from "./design/screens/admins";
import { AdminNotifications } from "./design/screens/admin-notifications";
import { Members } from "./design/screens/members";
import { AccountSettings } from "./design/screens/account";
import { Audit } from "./design/screens/audit";
import { Settings } from "./design/screens/settings";
import { FileTransfer } from "./design/screens/file-transfer";
import { DevBoard } from "./design/screens/dev-board";
import { Privacy, Terms } from "./design/screens/legal";
import { About, Features, CareAct, Adopt, Support } from "./design/screens/public-pages";
import { Inquiries } from "./design/screens/inquiries";
import { RegionManual } from "./design/screens/manual-region";
import { SystemManual } from "./design/screens/manual-system";
import { AgencyManual } from "./design/screens/manual-agency";
import { ManagerManual } from "./design/screens/manual-manager";
import { GuardianManual } from "./design/screens/manual-guardian";
import { ElderManual } from "./design/screens/manual-elder";
import { ForgotPassword } from "./design/screens/forgot-password";
import { PasswordReset } from "./design/screens/password-reset";
import { PasswordChange } from "./design/screens/password-change";
import { Offline } from "./design/screens/offline";
import { PwaLayer } from "./design/components/PwaInstall";

// ─── Canvas overview (all 23 screens laid out) ──────────────
function CanvasApp() {
  const D = { w: 1440, h: 900 };
  const M = { w: 390, h: 844 };
  return (
    <DesignCanvas>
      <DCSection id="landing" title="01 · 진입 · 랜딩 / PWA / 가입"
        subtitle="첫 만남: 권역·기관용 데스크톱 랜딩, 어르신·보호자용 모바일/PWA, 그리고 가입·로그인·비밀번호 찾기 화면.">
        <DCArtboard id="lan-d" label="랜딩 · 데스크톱" width={D.w} height={D.h}><LandingDesktop/></DCArtboard>
        <DCArtboard id="lan-m" label="랜딩 · 모바일/PWA" width={M.w} height={M.h}><LandingMobile/></DCArtboard>
        <DCArtboard id="auth"   label="회원가입 / 로그인" width={1280} height={832}><Auth/></DCArtboard>
        <DCArtboard id="forgot" label="비밀번호 찾기"     width={1280} height={832}><ForgotPassword/></DCArtboard>
      </DCSection>
      <DCSection id="dashboards" title="02 · 사용자별 대시보드"
        subtitle="권역 협회 관리자 · 플랫폼 운영자 · 현장 케어매니저 · 보호자(가족). 같은 케이스를 역할별 관점으로 본다.">
        <DCArtboard id="db-region"   label="권역 대시보드"      width={D.w} height={D.h}><DashboardRegion/></DCArtboard>
        <DCArtboard id="db-platform" label="플랫폼 대시보드"    width={D.w} height={D.h}><DashboardPlatform/></DCArtboard>
        <DCArtboard id="db-mgr"      label="케어매니저 대시보드" width={D.w} height={D.h}><DashboardCareManager/></DCArtboard>
        <DCArtboard id="db-guardian" label="보호자 대시보드"     width={M.w} height={M.h}><DashboardGuardian/></DCArtboard>
        <DCArtboard id="db-elder"    label="어르신 홈 (1인칭)"    width={M.w} height={M.h}><DashboardElder/></DCArtboard>
        <DCArtboard id="elder-help"  label="어르신 도움말"        width={M.w} height={M.h}><ElderHelp/></DCArtboard>
      </DCSection>
      <DCSection id="workflow" title="03 · 핵심 워크플로우"
        subtitle="AI 자동매칭(COD) · 지도 · 일정 · 승인. 권역의 매일을 움직이는 4개 화면.">
        <DCArtboard id="cod"      label="AI 자동매칭 (COD)" width={D.w} height={D.h}><COD/></DCArtboard>
        <DCArtboard id="map"      label="지도 — 기관 · 매니저 · 케이스" width={D.w} height={D.h}><MapView/></DCArtboard>
        <DCArtboard id="schedule" label="일정 관리 · 주간" width={D.w} height={D.h}><Schedule/></DCArtboard>
        <DCArtboard id="approval" label="승인 관리" width={D.w} height={D.h}><Approval/></DCArtboard>
      </DCSection>
      <DCSection id="masters" title="04 · 운영 마스터"
        subtitle="권역 · 유관기관(병원/소방/보건소 등) · 케어매니저 등록·관리.">
        <DCArtboard id="region-crud"  label="권역 관리 (플랫폼)" width={D.w} height={D.h}><RegionManagement/></DCArtboard>
        <DCArtboard id="org-crud"     label="유관기관 관리"      width={D.w} height={D.h}><OrgManagement/></DCArtboard>
        <DCArtboard id="mgr-crud"     label="케어매니저 관리"    width={D.w} height={D.h}><Management/></DCArtboard>
        <DCArtboard id="elderly-d"    label="어르신 상세 (운영)" width={D.w} height={D.h}><ElderlyDetail/></DCArtboard>
      </DCSection>
      <DCSection id="platform-ops" title="05 · 플랫폼 운영 · 리포트"
        subtitle="권역 리포트, 관리자·감사 로그·시스템 설정. 플랫폼 운영자와 시스템 관리자의 화면.">
        <DCArtboard id="report"   label="리포트 (권역)"      width={D.w} height={D.h}><Report/></DCArtboard>
        <DCArtboard id="admins"   label="관리자 (플랫폼)"    width={D.w} height={D.h}><Admins/></DCArtboard>
        <DCArtboard id="members"  label="회원 관리"          width={D.w} height={D.h}><Members/></DCArtboard>
        <DCArtboard id="audit"    label="감사 로그 (플랫폼)" width={D.w} height={D.h}><Audit/></DCArtboard>
        <DCArtboard id="settings" label="시스템 설정 (플랫폼)" width={D.w} height={D.h}><Settings/></DCArtboard>
      </DCSection>
      <DCSection id="mgr-mobile" title="05 · 케어매니저 모바일 PWA"
        subtitle="현장에서 가장 많이 쓰는 앱. 출동·체크인·기록·매칭제안까지 한 손으로.">
        <DCArtboard id="m-home"   label="매니저 홈"        width={M.w} height={M.h}><MgrHome/></DCArtboard>
        <DCArtboard id="m-visit"  label="방문 상세 · 체크인" width={M.w} height={M.h}><MgrVisit/></DCArtboard>
        <DCArtboard id="m-match"  label="AI 매칭 제안"      width={M.w} height={M.h}><MgrMatch/></DCArtboard>
        <DCArtboard id="m-map"    label="지도 · 내비"       width={M.w} height={M.h}><MgrMap/></DCArtboard>
        <DCArtboard id="m-cases"  label="내 케이스 목록"     width={M.w} height={M.h}><MgrCaseList/></DCArtboard>
        <DCArtboard id="m-case"   label="어르신 케이스 상세" width={M.w} height={M.h}><MgrCase/></DCArtboard>
        <DCArtboard id="m-report" label="방문 기록 작성"     width={M.w} height={M.h}><MgrReport/></DCArtboard>
        <DCArtboard id="m-reports" label="내 방문 기록(매니저)" width={M.w} height={M.h}><MgrReportsMobile/></DCArtboard>
        <DCArtboard id="case"     label="케이스 상세(데스크톱)"  width={D.w} height={D.h}><MgrCaseDesktop/></DCArtboard>
        <DCArtboard id="m-me"     label="내 정보 (매니저)"   width={M.w} height={M.h}><MgrMe/></DCArtboard>
        <DCArtboard id="m-org"    label="가용성 갱신 (기관)" width={M.w} height={M.h}><OrgAvailability/></DCArtboard>
        <DCArtboard id="resources" label="자원 조건검색"      width={D.w} height={D.h}><ResourceSearch/></DCArtboard>
        <DCArtboard id="m-refer"  label="받은 의뢰 (기관)"   width={M.w} height={M.h}><ReferralInbox/></DCArtboard>
      </DCSection>
      <DCSection id="guardian-mobile" title="07 · 어르신 · 보호자 모바일 PWA"
        subtitle="케어 신청부터 매일 알림·방문 이력까지. 가족이 곁에서 함께 보는 화면.">
        <DCArtboard id="m-apply"    label="케어 신청 (어르신)"   width={M.w} height={M.h}><CareApply/></DCArtboard>
        <DCArtboard id="m-notify"   label="알림함 (보호자)"     width={M.w} height={M.h}><NotifyCenter/></DCArtboard>
        <DCArtboard id="m-timeline" label="방문 이력 타임라인"  width={M.w} height={M.h}><VisitTimeline/></DCArtboard>
        <DCArtboard id="m-meds"     label="복약 (어르신)"       width={M.w} height={M.h}><MedCenter/></DCArtboard>
        <DCArtboard id="m-guardian-me"      label="내 정보 (보호자)"  width={M.w} height={M.h}><GuardianMe/></DCArtboard>
        <DCArtboard id="m-guardian-manager" label="담당 매니저 상세"   width={M.w} height={M.h}><GuardianManager/></DCArtboard>
      </DCSection>
      <DCSection id="public" title="08 · 공개 소개 페이지"
        subtitle="랜딩 상단 메뉴에서 진입하는 공개 페이지. 도입 안내·고객지원은 문의 접수 폼을 포함한다.">
        <DCArtboard id="about"    label="서비스 소개"      width={D.w} height={D.h}><About/></DCArtboard>
        <DCArtboard id="features" label="주요 기능"        width={D.w} height={D.h}><Features/></DCArtboard>
        <DCArtboard id="care-act" label="2026 통합돌봄법"  width={D.w} height={D.h}><CareAct/></DCArtboard>
        <DCArtboard id="adopt"    label="도입 안내"        width={D.w} height={D.h}><Adopt/></DCArtboard>
        <DCArtboard id="support"  label="고객지원"         width={D.w} height={D.h}><Support/></DCArtboard>
        <DCArtboard id="inq"      label="문의 관리(관리자)" width={D.w} height={D.h}><Inquiries/></DCArtboard>
      </DCSection>
      <DCSection id="legal" title="09 · 정책 · 약관"
        subtitle="개인정보처리방침과 이용약관. 푸터 링크에서 진입.">
        <DCArtboard id="privacy" label="개인정보처리방침" width={D.w} height={D.h}><Privacy/></DCArtboard>
        <DCArtboard id="terms"   label="이용약관"        width={D.w} height={D.h}><Terms/></DCArtboard>
      </DCSection>
    </DesignCanvas>
  );
}

const SCREENS = {
  "canvas":                CanvasApp,
  "landing-desktop":       LandingDesktop,
  "landing-mobile":        LandingMobile,
  "auth":                  Auth,
  "signup":                Signup,
  "dashboard-region":      DashboardRegion,
  "dashboard-platform":    DashboardPlatform,
  "dashboard-caremanager": DashboardCareManager,
  "dashboard-guardian":    DashboardGuardian,
  "dashboard-elder":       DashboardElder,
  "elder-help":            ElderHelp,
  "dashboard-agency":      DashboardAgency,
  "cod":                   COD,
  "map":                   MapView,
  "schedule":              Schedule,
  "approval":              Approval,
  "claims":                Claims,
  "region-management":     RegionManagement,
  "org-management":        OrgManagement,
  "management":            Management,
  "elderly-detail":        ElderlyDetail,
  "mgr-cases":             MgrCases,
  "visit-detail":          VisitDetail,
  "mgr-home":              MgrHome,
  "mgr-schedule":          MgrSchedule,
  "mgr-visit":             MgrVisit,
  "mgr-match":             MgrMatch,
  "mgr-map":               MgrMap,
  "mgr-case":              MgrCase,
  "mgr-cases-mobile":      MgrCaseList,
  "mgr-me":                MgrMe,
  "org-availability":      OrgAvailability,
  "resource-search":       ResourceSearch,
  "referral-inbox":        ReferralInbox,
  "mgr-notify":            MgrNotify,
  "mgr-report":            MgrReport,
  "mgr-reports":           MgrReportsMobile,
  "mgr-case-desktop":      MgrCaseDesktop,
  "care-apply":            CareApply,
  "sos":                   Sos,
  "notify-center":         NotifyCenter,
  "admin-notifications":   AdminNotifications,
  "visit-timeline":        VisitTimeline,
  "med-center":            MedCenter,
  "guardian-me":           GuardianMe,
  "guardian-manager":      GuardianManager,
  "message-thread":        MessageThread,
  "report":                Report,
  "admins":                Admins,
  "members":               Members,
  "account":               AccountSettings,
  "audit":                 Audit,
  "settings":              Settings,
  "file-transfer":         FileTransfer,
  "dev-board":             DevBoard,
  "manual-region":         RegionManual,
  "manual-system":         SystemManual,
  "manual-agency":         AgencyManual,
  "manual-manager":        ManagerManual,
  "manual-guardian":       GuardianManual,
  "manual-elder":          ElderManual,
  "privacy":               Privacy,
  "terms":                 Terms,
  "about":                 About,
  "features":              Features,
  "care-act":              CareAct,
  "adopt":                 Adopt,
  "support":               Support,
  "inquiries":             Inquiries,
  "mgr-privacy":           MgrPrivacy,
  "mgr-terms":             MgrTerms,
  "forgot-password":       ForgotPassword,
  "password-reset":        PasswordReset,
  "password-change":       PasswordChange,
  "offline":               Offline,
};

const el = document.getElementById("design-root");
if (el) {
  const name = el.dataset.screen || "canvas";
  const Screen = SCREENS[name];
  if (Screen) {
    // 모바일 화면에서만 PWA 설치/업데이트 레이어를 함께 마운트(PwaLayer 가 자체 게이트).
    const mobile = document.body.classList.contains("screen-mobile");
    createRoot(el).render(<><Screen /><PwaLayer mobile={mobile} /></>);
  } else {
    el.textContent = `Unknown screen: ${name}`;
  }
}

// ─── PWA: 서비스워커 등록 (설치형 + 오프라인 셸) ──────────────
// 등록 코드를 번들 내부에 두어 CSP(script-src 'self') 위반을 피한다.
// scope=/ 전역 등록이지만 fetch 전략상 navigation=network-first 라 데스크톱 동작은 불변.
if ("serviceWorker" in navigator) {
  // 업데이트 적용 시에만 새로고침한다. 최초 설치(clients.claim 으로 인한 컨트롤러 획득)
  // 에서는 새로고침하지 않는다 — 첫 방문 깜빡임 방지.
  let applyingUpdate = false;
  let waitingWorker: ServiceWorker | null = null;

  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (applyingUpdate) location.reload();
  });

  // P3 업데이트 토스트의 "새로고침"이 디스패치한다 → 대기 중 SW 활성화 → controllerchange → reload.
  window.addEventListener("pwa:apply-update", () => {
    if (!waitingWorker) return;
    applyingUpdate = true;
    waitingWorker.postMessage("skipWaiting");
  });

  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").then((reg) => {
      // 이미 대기 중인 새 버전이 있으면 즉시 업데이트 알림.
      if (reg.waiting && navigator.serviceWorker.controller) {
        waitingWorker = reg.waiting;
        window.dispatchEvent(new Event("pwa:update-available"));
      }
      // 새 버전(번들 해시 변경 → SW 본문 변경) 설치 감지 시 업데이트 알림.
      reg.addEventListener("updatefound", () => {
        const sw = reg.installing;
        if (!sw) return;
        sw.addEventListener("statechange", () => {
          if (sw.state === "installed" && navigator.serviceWorker.controller) {
            waitingWorker = sw;
            window.dispatchEvent(new Event("pwa:update-available"));
          }
        });
      });
    }).catch(() => { /* SW 미지원/실패는 조용히 무시 — 앱은 정상 동작 */ });
  });
}


